var rich_content_viewer_default = {
  "fontElementMap": "OlzHS",
  "wrapper": "_9rhEd",
  "pluginContainerMobile": "_9j3-5",
  "viewer": "zr1cm",
  "android": "oO5uQ",
  "rootedTraversedContent": "_04jTM",
  "atomic": "ObzNb",
  "toolbar": "zhcfu",
  "block": "_3aKg0"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
